<template>
    <div>
        <el-button  size="small"  type="success" @click="newMater()" style="margin-bottom: 15px;">新建明细</el-button>
        <el-table
            :data="returnData"
            border
            :header-cell-style="{'text-align':'center'}"
            style="width: 100%"
            >
            <el-table-column
                align="center"
                type="index"
                width="50"
                label="序号">
            </el-table-column>
            <el-table-column
                align="center"
                label="操作"
                width="50">
                <template slot-scope="scope">
                    <el-button @click.stop="deleteRow(scope.$index,scope.row, returnData)" type="text" size="small">移除</el-button>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                prop="materialCode"
                label="物料编号">
            </el-table-column>
            <el-table-column
                align="center"
                prop="modelName"
                width="150"
                label="型号">
            </el-table-column>
            <el-table-column
                align="center"
                prop="materialName"
                label="物料名称">
            </el-table-column>
            <el-table-column
                align="center"
                width="200"
                label="到店数量">
                <template slot-scope="scope">
                  <el-input-number controls-position="right" size="small" v-model="scope.row.aogSum" :min="1"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                width="200"
                label="入库数量">
                <template slot-scope="scope">
                  <el-input-number controls-position="right" size="small" v-model="scope.row.inboundSum" @change="changeNumber()" :min="1" :max="scope.row.aogSum"></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                prop="price"
                width="150"
                :formatter="addCommas"
                label="入库单价(元)">
                <template slot-scope="scope">
                  <el-input type="number" size="small" v-model="scope.row.price" @change="changeAmount(scope.row)"></el-input>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                prop="shouldInPrice"
                width="150"
                :formatter="addCommas"
                label="应入价(元)">
                <template slot-scope="scope">
                  <el-input type="number" size="small" v-model="scope.row.shouldInPrice"></el-input>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                prop="amount"
                :formatter="addCommas"
                label="合计金额(元)">
                <template slot-scope="scope">
                    {{scope.row.amount = Number(scope.row.price) * Number(scope.row.inboundSum)}}
                </template>
            </el-table-column>
        </el-table>
        <div class="totalDiv">
            <small>数量：</small>
            <strong>{{totalCount}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;
            <small>总计：</small>
            <strong>{{totalMoney}}</strong> 元
        </div>
        <el-dialog title="新建物料信息" :visible.sync="dislogMater" :close-on-click-modal="false" width="800px"  @close="emptyNew()">
            <el-row>
                <el-col>
                    <ul class="clearfix" style="margin-bottom: 15px;">
                        <span class="fl headerSpan">品牌</span>
                        <li class="fl listPart" v-for="(item,index) in brandLists" :key="index" @click="selectBrand(item,index)" v-bind:class="{active:activeBrandIndex===index}">{{item.brandName}}</li>
                    </ul>
                    <transition name="fade" mode="out-in" appear>
                        <ul class="clearfix" style="margin-bottom: 15px;" v-if="categoryLists.length !== 0 ">
                            <span class="fl headerSpan">品类</span>
                            <li @click="selectCategory(item,index)" class="fl listPart" v-for="(item,index) in categoryLists" :key="index" v-bind:class="{active:activeCategoryIndex===index}">{{item.categoryName}}</li>
                        </ul>
                    </transition>
                    <transition name="fade" mode="out-in" appear>
                        <ul class="clearfix" style="margin-bottom: 15px;" v-if="modelLists.length !== 0 ">
                            <span class="fl headerSpan">型号</span>
                            <li @click="selectModel(item,index)" v-bind:class="{active:activeModelIndex===index}" class="fl listPart" v-for="(item,index) in modelLists" :key="index">{{item.modelName}}</li>
                        </ul>
                    </transition>
                    <el-form ref="modelForm" style="width:100%;margin-bottom:20px" :inline="true" label-width="75px" :model="modelForm" :label-position="labelPosition">
                        <el-form-item style="margin-bottom:15px" label="物料编码">
                            <el-select v-model.trim="modelForm.materialCode" placeholder="请选择物料编号" @change="getMaterNumberList" clearable filterable>
                                <el-option v-for="(item,index) in newData"
                                    :label="item.materialCode"
                                    :value="item.materialCode"
                                    :key="index">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-bottom:15px" label="物料名称">
                            <el-select v-model.trim="modelForm.materialName" filterable @change="getMaterNumberList" placeholder="请选择物料名称"  clearable>
                                <el-option v-for="(item,index) in newData"
                                    :label="item.materialName"
                                    :value="item.materialName"
                                    :key="index">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-table
                :data="newData"
                border
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                <el-table-column
                    align="center"
                    prop="brandName"
                    label="品牌">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="categoryName"
                    label="品类">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="modelName"
                    label="型号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialCode"
                    label="物料编号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialName"
                    label="物料名称">
                </el-table-column>
                <el-table-column
                    align="center"
                    type="selection"
                    width="55">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="success" @click="addEventFormSubmitBtn()">添加</el-button>
                <el-button @click="emptyNew()">取 消</el-button>
            </span>
        </el-dialog>
        <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" :disabled="isSubmit" @click.native="DetermineSave()">提交</el-button>
        <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" :disabled="isSubmit" @click.native="DetermineSave1()">暂存</el-button>
        <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" :disabled="isSubmit" @click.native="deleteSerial">删除</el-button>
        <el-dropdown split-button type="primary" trigger="click" class="fr" style="margin: 50px 20px 50px 0;">
            {{pageStatus}}
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="closeSave()">离开当前页面</el-dropdown-item>
                <!-- <el-dropdown-item @click.native="goOnSave()">留在当前页面</el-dropdown-item> -->
            </el-dropdown-menu>
        </el-dropdown>
        <el-button type="primary" class="fr" style="margin: 50px 20px 50px 0;" @click="cancelOrder()">取消新建</el-button>
    </div>
</template>

<script>
  import {hideLoading, showLoading} from "../loading/loading";

    let moment = require("moment");
    import clip from '@/util/clipboard'
    import {
        selectAllBrand,
        selectCategory,
        selectModel,
        getMaterialListByWarehouse,
        inboundAdd,
        inboundSave,
        inboundUpdateAndSubmit,
        saveAndUpdate,
        removeEntry,
        inboundRemove,
        inboundDetailsList
    } from "../../api/api";
    export default{
        props: {
            searchForm: {
               type: Object
            }
        },
        inject: ['reload'],
        data(){
            return{
                totalCount:0, //物料总数量
                totalMoney:0, //总金额
                dislogMater:false, // 新建明细弹出框
                defaultBrandId:'',
                defaultCategoryId:'',
                defaultModelId:'',
                brandLists:'',
                categoryLists:'',
                modelLists:'',
                activeBrandIndex:"",
                activeCategoryIndex:"",
                activeModelIndex:"",
                materialCode:'',
                materNumberList:[],
                newData: [],
                returnData: [],
                pageStatus:'离开当前页面',
                saveStatus:'YQR',
                parentForm:this.searchForm,
                multipleSelection:[],
                labelPosition:'left',
                isSubmit:false,
                modelForm:{
                    materialCode:'',
                    materialName:''
                },
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10000,
                }
            }
        },
        created(){
            this.getInboundDetailsList();
        },
        methods: {
            //删除数据
            deleteSerial(){
                let para={
                    id: this.searchForm.orderId
                };
                showLoading();
                inboundRemove(para).then(res => {
                  hideLoading();
                  if (res.data.status==100) {
                        this.$message({
                            message: res.data.message,
                            type: "success"
                        });
                        this.tabRemove(this.$route.path);
                        this.$router.replace({
                            path:'/accessStoreManage'
                        });
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取选中型号的物料数据 => 数组
            handleSelectionChange(val) {
                if(val != []){
                    this.multipleSelection = val;
                }
            },
            //清空dialogValue
            emptyNew() {
                this.dislogMater = false
            },
            newMater(){
                if(this.searchForm.warehouseType==""){
                    this.$message({
                        message: '请选择出入库仓库再提交',
                        type: 'warning'
                    });
                    return
                }
                this.dislogMater = true
                if(this.brandLists.length == 0 || this.returnData.length == 0){
                    this.getBrandLists();
                }
            },
            //获取订单详情分页
            getInboundDetailsList() {
                console.log(this.searchForm)
                let para={
                    id: this.searchForm.orderId,
                    startRow:this.pages.page,
                    pageSize:this.pages.pageSize
                }
                inboundDetailsList(para).then(res => {
                    if (res.data.status == '100') {
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total
                        this.getAllMoney();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                  this.$Message.error(error.message);
                })
            },
            //查询品牌or获取品牌
            getBrandLists() {
                selectAllBrand().then(res => {
                    if (res.data.status==100) {
                        this.brandLists = res.data.results;
                        this.defaultBrandId = res.data.results[0].brandId;
                        this.activeBrandIndex = 0;
                        this.getCategoryList(this.defaultBrandId);
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //选中品牌
            selectBrand(item,index) {
                this.activeBrandIndex = index;
                this.defaultBrandId = Object.assign({}, item).brandId;
                this.getCategoryList(this.defaultBrandId);
                this.newData = [];
            },
            //获取品类
            getCategoryList(id){
                const brandId = id
                const brandData = {brandId:brandId}
                selectCategory(brandData).then((res) => {
                  if (res.data.status == 100) {
                        this.categoryLists = res.data.results;
                        this.defaultCategoryId = res.data.results[0].categoryId;
                        this.activeCategoryIndex = 0;
                        this.getModelList(this.defaultBrandId,this.defaultCategoryId);
                  }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                  }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            //选中品类
            selectCategory(item,index) {
                this.activeCategoryIndex = index;
                this.defaultCategoryId = Object.assign({}, item).categoryId;
                this.getModelList(this.defaultBrandId,this.defaultCategoryId);
            },
            //获取型号
            getModelList(id1,id2){
                let para = {
                    brandId:id1,
                    categoryId:id2,
                }
                selectModel(para).then(res => {
                    if (res.data.status==100) {
                        this.modelLists = res.data.results;
                        this.defaultModelId = res.data.results[0].modelId;
                        this.activeModelIndex = 0;
                        this.getMaterNumberList();
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //选中型号
            selectModel(item,index) {
                this.activeModelIndex = index
                this.defaultModelId = Object.assign({}, item).modelId
                this.getMaterNumberList()
            },
            //获取物料编号
            getMaterNumberList(){
                let para={
                    brandId: this.defaultBrandId,
                    categoryId:this.defaultCategoryId,
                    modelId: this.defaultModelId,
                    requestType:'warehouseing',
                    materialCode:this.modelForm.materialCode,
                    materialName:this.modelForm.materialName,
                    //warehouseType:this.searchForm.warehouseType
                }
                getMaterialListByWarehouse(para).then(res => {
                    if (res.data.status==100) {
                        this.newData = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //提交添加明细
            addEventFormSubmitBtn() {
                let isHave = false;
                let isArray = [];
                let isThere = [];
                if(this.returnData.length == 0){
                    this.multipleSelection.forEach((item2,index2,array) =>{
                        if(array.indexOf(item2) === index2) {
                            this.returnData.push({
                                materialCode: item2.materialCode,
                                materialCoding:item2.materialCoding,
                                materialName: item2.materialName,
                                modelId:item2.modelId,
                                modelName:item2.modelName,
                                inboundSum:1,
                                price:"",
                                aogSum:0,
                                shouldInPrice:0
                            })
                        }
                    })
                }else{
                    this.multipleSelection.forEach((item,index)=>{
                        isHave = false;
                        this.returnData.forEach((item1,index1)=>{
                            if(item.materialCode == item1.materialCode){
                                isHave = true;
                                isThere.push(item.materialName);
                            }
                        })
                        if(!isHave){
                            isArray.push(item);

                        }
                    });
                    isArray.forEach((item,index)=>{
                        this.returnData.push({
                            materialCode: item.materialCode,
                            materialCoding:item.materialCoding,
                            materialName: item.materialName,
                            modelId:item.modelId,
                            modelName:item.modelName,
                            inboundSum:1,
                            price:"",
                            aogSum:0,
                            shouldInPrice:0
                        })
                    })
                }
                this.getAllMoney() //计算总数
                this.dislogMater = false;
                if(isThere.length > 0){
                    let materialStr = isThere.join('、');
                    this.$message({
                        message: "列表中已存"+materialStr+"，请手动输入数量",
                        type: "warning"
                    });
                }
            },
            changeNumber(){
                this.getAllMoney();
            },
            changeAmount(row){
                this.getAllMoney();
                row.shouldInPrice = row.price;
            },
            //移除订单
            deleteRow(index,row, rows) {
                console.log(row.id);
                if(row.id != undefined){
                    let ids = [];
                    ids.push(row.id.toString());
                    let para={
                        parentId:this.searchForm.orderId,
                        ids:ids
                    };
                    showLoading();
                    removeEntry(para).then(res => {
                      hideLoading();
                      if (res.data.status==100) {
                            if(rows.length > 0){
                                this.totalCount = this.totalCount - Number(rows[index].inboundSum)
                                this.totalMoney = this.totalMoney - Number(rows[index].amount)
                            }else{
                                this.totalCount = 0
                                this.totalMoney = 0
                            }
                            rows.splice(index, 1);
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }else{
                    if(rows.length > 0){
                        this.totalCount = this.totalCount - Number(rows[index].inboundSum)
                        this.totalMoney = this.totalMoney - Number(rows[index].amount)
                    }else{
                        this.totalCount = 0
                        this.totalMoney = 0
                    }
                    rows.splice(index, 1);
                }
            },
            // 汇总数量和金额
            getAllMoney() {
                this.totalCount = 0
                this.totalMoney = 0
                if (this.returnData) {
                    this.returnData.forEach(element => {
                        this.totalCount += element.inboundSum
                        this.totalMoney = this.totalMoney + Number(element.price) * Number(element.inboundSum)
                    })
                }
            },
            tabRemove (targetName) {
                // 首页不可删除
                if(targetName == '/') {
                    return;
                }
                //将该tab从options里移除
                this.$store.commit('delete_tabs', targetName);
              ////还同时需要处理一种情况当需要移除的页面为当前激活的页面时，将上一个tab页作为激活tab
                if (this.activeIndex === targetName) {
                    // 设置当前激活的路由
                    if (this.options && this.options.length >= 1) {
                        this.$store.commit('set_active_index', this.options[this.options.length-1].route);
                        this.$router.push({path: this.activeIndex});
                    } else {
                        this.$router.push({path: '/welcome'});
                    }
                }
            },
            //金额转化函数
            addCommas:function(row,column){
                var num = row[column.property];
                //var b= num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            //提交
            DetermineSave(){
                this.saveStatus = 'YQR';
                if (this.searchForm.inbound_type=="") {
                    this.$message({
                        message: '请选择出入库类型再提交',
                        type: 'warning'
                    });
                }else if(this.searchForm.warehouseType==""){
                    this.$message({
                        message: '请选择出入库仓库再提交',
                        type: 'warning'
                    });
                }else if(!this.searchForm.supplierId){
                    this.$message({
                        message: '请选择供应商，再提交',
                        type: 'warning'
                    });
                }else if(this.returnData.length == 0){
                    this.$message({
                        message: '请新建物料明细并选择，再提交',
                        type: 'warning'
                    });
                }else{
                    // this.isSubmit = true;
                    // let para={
                    //     type: this.searchForm.inbound_type,
                    //     warehouseType:this.searchForm.warehouseType,
                    //     inboundSum:this.totalCount,
                    //     amount:this.totalMoney,
                    //     inboundDetailsList: this.returnData,
                    //     supplierId:this.searchForm.supplierId,
                    //     status:this.saveStatus,
                    //     memo:this.searchForm.memo
                    // }
                    this.isSubmit = true;
                    let inbound = {
                        id:this.searchForm.orderId,
                        supplierId:this.searchForm.supplierId,
                        memo:this.searchForm.memo
                    }
                    console.log(this.returnData)
                    let para={
                        // type: this.searchForm.inbound_type,
                        // warehouseType:this.searchForm.warehouseType,
                        // inboundSum:this.totalCount,
                        // amount:this.totalMoney,
                        inbound:inbound,
                        entryList: this.returnData,
                        // supplierId:this.searchForm.supplierId,
                        // status:this.saveStatus,
                        // memo:this.searchForm.memo
                    };
                    showLoading();
                    inboundUpdateAndSubmit(para).then(res => {
                      hideLoading();
                      if (res.data.status==100) {
                            this.$message({
                                message: res.data.message,
                                type: "success"
                            });
                            if (this.pageStatus == '离开当前页面') {
                                this.tabRemove(this.$route.path)
                                this.$router.replace({
                                    path:'/accessStoreManage'
                                });
                            }
                            this.refresh(); //刷新
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                        this.isSubmit = false;
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }
            },
            //暂存
            DetermineSave1(){
                this.saveStatus = 'save';
                if (this.searchForm.inbound_type=="") {
                    this.$message({
                        message: '请选择出入库类型再提交',
                        type: 'warning'
                    });
                }else if(this.searchForm.warehouseType==""){
                    this.$message({
                        message: '请选择出入库仓库再提交',
                        type: 'warning'
                    });
                }else if(!this.searchForm.supplierId){
                    this.$message({
                        message: '请选择供应商，再提交',
                        type: 'warning'
                    });
                }else if(this.returnData.length == 0){
                    this.$message({
                        message: '请新建物料明细并选择，再提交',
                        type: 'warning'
                    });
                }else{
                    // this.isSubmit = true;
                    // let para={
                    //     type: this.searchForm.inbound_type,
                    //     warehouseType:this.searchForm.warehouseType,
                    //     inboundSum:this.totalCount,
                    //     amount:this.totalMoney,
                    //     inboundDetailsList: this.returnData,
                    //     supplierId:this.searchForm.supplierId,
                    //     status:this.saveStatus,
                    //     memo:this.searchForm.memo
                    // }
                    this.isSubmit = true;
                    let inbound = {
                        id:this.searchForm.orderId,
                        supplierId:this.searchForm.supplierId,
                        memo:this.searchForm.memo
                    }
                    console.log(this.returnData)
                    let para={
                        // type: this.searchForm.inbound_type,
                        // warehouseType:this.searchForm.warehouseType,
                        // inboundSum:this.totalCount,
                        // amount:this.totalMoney,
                        inbound:inbound,
                        entryList: this.returnData,
                        // supplierId:this.searchForm.supplierId,
                        // status:this.saveStatus,
                        // memo:this.searchForm.memo
                    };
                    showLoading();
                    saveAndUpdate(para).then(res => {
                      hideLoading();
                      if (res.data.status==100) {
                            this.$message({
                                message: res.data.message,
                                type: "success"
                            });
                            if (this.pageStatus == '离开当前页面') {
                                this.tabRemove(this.$route.path)
                                this.$router.replace({
                                    path:'/accessStoreManage'
                                });
                            }
                            this.refresh(); //刷新
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                        this.isSubmit = false;
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }
            },
            closeSave(){
                this.pageStatus = "离开当前页面"
            },
            goOnSave(){
                this.pageStatus = "留在当前页面"
            },
            //取消新建
            cancelOrder(){
                this.tabRemove(this.$route.path)
                this.$router.replace({
                    path:'/accessStoreManage'
                })
            },
            refresh(){
                this.searchForm.warehouseType = '';
                this.searchForm.memo = '';
                this.returnData = [];
                this.totalMoney = 0;
                this.totalCount = 0;
                this.multipleSelection = [];
            }
        },
        computed: {
            searchStatus: function () {
                return this.parentForm // 直接监听props里的status状态
            }
        },
        watch: {
            searchForm (newV, oldV) { // watch监听props里status的变化，然后执行操作
                this.parentForm = newV
            }
        }
    }
</script>

<style scoped lang="scss">
    .headerSpan{
        margin-right:20px
    }
    .listPart{
        border:1px solid #c6c6c6;
        margin:-8px 15px 18px 0;
        border-radius: 5px;
        text-align: center;
        position: relative;
        z-index: 0;
        cursor: pointer;
        padding: 5px 10px;
    }
    li.active{
        background-color:#1abc9c;
        color:#fff;
        border-color: #1abc9c;
    }
    .activeBtn{
        background-color: #1abc9c;
        color:#fff;
    }
    .el-step__line{
        background-color: #1abc9c;
    }
    .el-step__icon-inner{
        color:#1abc9c;
    }
    .el-step__icon.is-text{
        border-color: #1abc9c;
    }
    .totalDiv{
        height: auto;
        overflow: hidden;
        text-align: right;
        font-size: 16px;
        background-color: #fff;
        border-bottom: 1px solid #e5e9f2;
        padding: 10px;
    }
</style>



// WEBPACK FOOTER //
// purchaseAccess.vue?2f3bd9c7